const ACTIONS = {
    UPDATE_AVAILABILITY: 'LISTING_AVAILABILITY/UPDATE_AVAILABILITY'
};

const ACTION_CREATORS = {
    updateAvailability(availabilityData) {
        return {
            type: ACTIONS.UPDATE_AVAILABILITY,
            payload: {
                availabilityData
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
